import { useId, useState } from "react";

import { seedFromId } from "./rarityLook.js";

/**
 * Whether an element wearing its rarity is awake (hovered or focused), the handlers that wake it,
 * and its seed: where its RarityEffects and RarityName are in their motion. Spread `wake` on the
 * element the shopper points at; pass `active` and `seed` to the rarity parts inside it. At rest
 * the rarity look holds still, so a page of rarity costs nothing to sit on; only the awake one
 * moves.
 */
export function useRarityWake(seed?: number) {
  const id = useId();
  const [active, setActive] = useState(false);
  const wake = {
    onPointerEnter: () => setActive(true),
    onPointerLeave: () => setActive(false),
    onFocus: () => setActive(true),
    onBlur: () => setActive(false),
  };
  return { active, wake, seed: seed ?? seedFromId(id) };
}
